import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import * as React from "react";
import { Location } from "history";
import { MEMBERS_PORTAL } from "../../../accounts/Consts";
import { msalConfig } from "../../../accounts/types/msalAuthConfig";
import { AppInsightsService } from "../../../telemetry/services/AppInsightsService";

export interface IAuthRouteWatcherProps {
    location: Location;
    portalType: string;
}

export const useAuthRouteWatcher = (location: Location, portalType: string): void => {
    const { instance, accounts } = useMsal();

    React.useEffect(() => {
        if (portalType !== MEMBERS_PORTAL) return;
        if (location.pathname === "/aadB2CLogin") return;


        const ensureToken = async () => {
            const account = accounts[0];

            if (!account) {
                await instance.loginRedirect({ scopes: [msalConfig.auth.scope] });
                return;
            }

            try {
                const tokenResponse = await instance.acquireTokenSilent({
                    scopes: [msalConfig.auth.scope],
                    account,
                    authority: msalConfig.auth.authority
                });

                const email = account?.username || (account?.idTokenClaims as any)?.email;

                if (email) {
                    AppInsightsService.setAuthenticatedUser(email);
                }
            } catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                    await instance.loginRedirect({ scopes: [msalConfig.auth.scope] });
                    return;
                }
                throw error;
            }
        };

        ensureToken();
    }, [accounts, instance, location.pathname, location.search, location.hash, portalType]);
};
